import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboarddemoService } from '../Dashboad1.service';
import { EmployeeService } from '../../employee-profile/employee-profile.service';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { SharedSkillService } from '../../skill-repository/shared-skill.service';

@Component({
  selector: 'app-profile-card1',
  templateUrl: './profile-card.component.html',
  styleUrls: ['./profile-card.component.css']
})
export class ProfileCarddemoComponent implements OnInit {
  data: any;
  employeeId: number;
  userId: any;
  employeeInfo: any;
  courseCompleted: number = 0;
  totalCourses: number = 0;
  programPendingRequestCount: number = 0;
  myBadges: number = 0;
  exp: any;
  employeeProfileInfo: any;


  constructor(private router: Router, private service: DashboarddemoService, private employeeService: EmployeeService, private toastr: ToastrService, private shareSkillService: SharedSkillService, private auth: AuthServiceService) { }

  ngOnInit() {
    this.employeeId = parseInt(localStorage.getItem('Id'));
    //this.GetUserProgramDetailsByEmployeeId(this.employeeId);
    //this.getEmployeeInfo(this.employeeId);

  }

  redirectToPage() {
    this.router.navigate(['Home/Profile-view1']);
  }
  GetUserProgramDetailsByEmployeeId(employeeId: number) {
    this.service.GetUserProgramDetailsByEmployeeId(employeeId).subscribe(x => {
      this.data = x.value;
      this.courseCompleted = this.data.courseCompleted;
      this.totalCourses = this.data.totalCourses;
      this.programPendingRequestCount = this.data.programPendingRequestCount;
      this.myBadges = this.data.myBadges;
      this.userId = this.data.userId;
      localStorage.setItem('userId', this.userId);


    });
  }

  getEmployeeInfo(employeeId: number) {
    this.employeeService.getEmployeeDetails(employeeId).subscribe(res => {
      if (res.data) {
        this.employeeInfo = res.data;
        this.exp = this.employeeInfo.experience;
        if (this.exp >= 1) {
          this.exp = Math.floor(this.exp);
        }
      }
      else {
        this.toastr.warning("No Data of employee");
      }
    });

  }
  naviagateToEmployeeDetails() {
    this.shareSkillService.setEmployeeId(this.employeeId)
    this.shareSkillService.setMode(false)
    this.router.navigate(["Home/employee-details"])
  }
}
